export default __webpack_public_path__ + "static/N0214-4e2790fd1c911a0e2cf58e3a8dc2afc4.png";